export const Types = {
    GET_ROLE_GROUP_BY_ID: "GET_ROLE_GROUP_BY_ID",
    SET_ROLE_GROUP_BY_ID: "SET_ROLE_GROUP_BY_ID",
    GET_ROLE_FUNCTION_LIST: "GET_ROLE_FUNCTION_LIST",
    SET_ROLE_FUNCTION_LIST: "SET_ROLE_FUNCTION_LIST",
    GET_ROLE_MENU_LIST: "GET_ROLE_MENU_LIST",
    SET_ROLE_MENU_LIST: "SET_ROLE_MENU_LIST",
    EDIT_RELATION: "EDIT_RELATION",
    SET_EDIT_RELATION: "SET_EDIT_RELATION",
    GET_ROLE_GROUP_LIST: "GET_ROLE_GROUP_LIST",
    SET_ROLE_GROUP_LIST: "SET_ROLE_GROUP_LIST",
    ADD_ROLE_GROUP: "ADD_ROLE_GROUP",
    UPDATE_ROLE_GROUP: "UPDATE_ROLE_GROUP",
    DELETE_ROLE_GROUP: "DELETE_ROLE_GROUP",

    RESET_APP_RESPONSE: "RESET_APP_RESPONSE",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getRoleGroupbyID = (payload) => ({
    type: Types.GET_ROLE_GROUP_BY_ID,
    payload: payload,
});

export const setRoleGroupbyID = (payload) => ({
    type: Types.SET_ROLE_GROUP_BY_ID,
    payload: payload,
});

export const getRoleFunctionList = () => ({
    type: Types.GET_ROLE_FUNCTION_LIST,
});

export const setRoleFunctionList = (payload) => ({
    type: Types.SET_ROLE_FUNCTION_LIST,
    payload: payload,
});

export const getRoleMenuList = () => ({
    type: Types.GET_ROLE_MENU_LIST,
});

export const setRoleMenuList = (payload) => ({
    type: Types.SET_ROLE_MENU_LIST,
    payload: payload,
});

export const editRelation = (payload) => ({
    type: Types.EDIT_RELATION,
    payload: payload,
});

export const seteditRelation = (payload) => ({
    type: Types.SET_EDIT_RELATION,
    payload: payload,
});

export const getRoleGroupList = (payload) => ({
    type: Types.GET_ROLE_GROUP_LIST,
});

export const setRoleGroupList = (payload) => ({
    type: Types.SET_ROLE_GROUP_LIST,
    payload: payload,
});

export const addRoleGroup = (payload) => {
    return {
        type: Types.ADD_ROLE_GROUP,
        payload: payload,
    };
};

export const updateRoleGroup = (payload) => {
    return {
        type: Types.UPDATE_ROLE_GROUP,
        payload: payload,
    };
};

export const deleteRoleGroup = (payload) => {
    return {
        type: Types.DELETE_ROLE_GROUP,
        payload: payload,
    };
};

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
